const NumScore = ({text1, num, text2}) => {
    return(
        <div className="font-inter">
            {text1 && <p className="text-[21px] font-medium">{text1}</p>}
            {(num || text2) && <span className="flex flex-row">
                    {num && <p className="text-[36px] font-bold text-[#00CAFF]">{num}</p>}
                    {text2 && <p className="text-[18px] font-medium m-auto ml-1">{text2}</p>}
                </span>}
        </div>
    )
}
export default NumScore